import {
  Button,
  Form,
  InputTextField,
  Loading,
  Spacer,
  TextLargeParagraphTitle,
} from '@carboncopyco/ui';
import { getMMMDYYYYathmmA } from '@carboncopyco/utils';
import { useEffect, useState } from 'react';
import { object, string } from 'yup';
import './style.css';
import { useGetWorkspacesQuery } from '@carboncopyco/data';
import { useUser, useWorkspaces } from '../../store/context';
import { WorkspaceSelectionField } from '../Workspaces/WorkspaceSelectionField';

export interface SaveRecordProps {
  onCancel: () => void;
  submitForm: (data: any) => any;
  curTitle: string;
  recordingStarted: boolean;
  isLoading: boolean;
  folderId?: string;
}

export const newRecordingSchema = object({
  cloneName: string().max(300).required(),
  description: string().max(300),
});

export const SaveRecording = ({
  onCancel,
  submitForm,
  curTitle,
  recordingStarted,
  isLoading,
  folderId,
}: SaveRecordProps) => {
  const [recordingName, setRecordingName] = useState<string>();
  const { activeOrganization, me } = useUser();
  const { activeWorkspace } = useWorkspaces();

  const { data } = useGetWorkspacesQuery(
    {
      organizationId: activeOrganization?.id.toString(),
    },
    { skip: !activeOrganization }
  );
  const workspaces = data || [];

  const workspaceId = activeWorkspace.current.id || workspaces?.[0].id;

  const initialValues = {
    cloneName: recordingName || '',
    description: `Clone of ${recordingName || ''}\nCloned by ${
      me?.first_name || ''
    } on ${getMMMDYYYYathmmA()}`,
    workspaceId,
  };

  const inFolder = folderId && folderId !== '0';

  useEffect(() => {
    if (recordingStarted) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      !recordingName && setRecordingName(curTitle);
    }
  }, [recordingStarted, setRecordingName, curTitle, recordingName]);
  return workspaceId ? (
    <div style={{ width: '300px' }}>
      <Form
        enableReinitialize
        onSubmit={submitForm}
        initialValues={initialValues}
        validationSchema={newRecordingSchema}
      >
        <>
          <TextLargeParagraphTitle
            color="text-ds-natural-600"
            label="Finish cloning?"
          />
          <Spacer amount={3} />

          <InputTextField
            required
            label="Clone Name"
            name="cloneName"
            dataDsId="recording-name-field"
          />
          <div className="ds-input-text-field-wrapper">
            <InputTextField
              label="Description"
              name="description"
              multiline
            />
          </div>

          <Spacer amount={4} />
          {!inFolder && (
            <WorkspaceSelectionField
              workspaces={workspaces}
              label="Save to"
              name="workspaceId"
            />
          )}
          <Spacer amount={4} />
          <div className="w-full flex justify-end">
            <Button
              label="Cancel"
              link
              onClick={onCancel}
            />
            <Spacer />
            <Button
              label="Save clone"
              submit
              leftIcon={
                isLoading ? <Loading color="text-current" /> : undefined
              }
              disabled={isLoading}
            />
          </div>
          <Spacer amount={1} />
        </>
      </Form>
    </div>
  ) : null;
};
